import UsersList from "../components/UserData/UserList";

const UserPage:  React.FC = () => {
    return(
        <UsersList />
    );
}
export default UserPage;